export default __webpack_public_path__ + "static/media/example-army-IMG.818e6ba7.jpg";